import { Component, Input } from '@angular/core';
import { FeatureFlag, OrgTypes } from '@mode/shared/contract-common';
import { getInitialFlagValue } from '@mode/shared/util-js';
import { ThoughtspotIntegrationService } from '@mode/shared/util-thoughtspot-integrated';

/* eslint-disable @nx/workspace/enforce-change-detection-on-push */
@Component({
  selector: 'mode-nav-home-links',
  templateUrl: './nav-home-links.component.html',
  styleUrls: ['./nav-home-links.component.scss'],
})
export class NavHomeLinksComponent {
  @Input() target?: string;
  @Input() personalCollectionToken? = '';
  @Input() currentOrg?: OrgTypes.Organization;
  isEnableDiscoverPageForStudioPlanEnabled = getInitialFlagValue(FeatureFlag.EnableDiscoverPageForStudioPlan);
  isAnalystStudio$ = this.thoughtspotIntegrationService.currOrgIntegrated$;

  constructor(private thoughtspotIntegrationService: ThoughtspotIntegrationService) {}
}
